module.exports = __webpack_public_path__ + "static/media/statistiche.d2c4be8d.png";